export default __webpack_public_path__ + "static/media/order.a15e968d.svg";